/*
 * @Author: qiong
 * @LastEditTime: 2021-09-23 11:05:29
 */
import { observable, action, flow, computed, toJS } from 'mobx';
import { rstr2b64 } from 'utils/md5';
import Util from 'utils';
import Config from 'config/Config';
import { Toast } from 'antd-mobile';
import Stores from 'config/Stores';
import Serv from './indexServ';
import { indexOf } from 'lodash';

class BusinessCard {
  // 名片
  @observable info = {};

  @observable decyptInfo = {};

  // 是否解密
  @observable isSecret = true;

  constructor() {
    this.init();
  }

  @action
  init() {
    const { decyptInfo } = Util.getLocalCache(Config.localStorageKeys.bussiness_card) || {};
    this.decyptInfo = decyptInfo || {};
    this.isSecret = !this.decyptInfo.phone;
  }

  /**
   * 修改逻辑参数
   */
  @action
  changeState(obj) {
    Object.keys(obj).forEach((key) => {
      this[key] = obj[key];
    });
  }

  /**
   * 获取名片详情
   */
  getCardInfo = flow(function* (id) {
    try {
      const { decyptInfo } = Util.getLocalCache(Config.localStorageKeys.bussiness_card) || {};
      const res = yield Serv.getCardInfo(id ? { id } : '');
      if (res.resultCode === '0') {
        this.info = { ...res.data, ...this.decyptInfo, ...decyptInfo } || {};
        // 已登录状态 解密姓名
      }
      return res;
    } catch (error) {}
  });

  @action
  clearData() {
    this.info = {};
    this.decyptInfo = {};
  }
}
const businessCard = new BusinessCard();
export default businessCard;



// WEBPACK FOOTER //
// ./src/pubBiz/BusinessCard/indexMod.js